import $ from 'jquery';

class Filter {
    constructor(injector) {
        this.injector = injector;
        this.filters = [];
        this.init();
    }

    init() {
        this.$filters = $('.js-filter select');

        this.$filters.each((i, e) => {
            this.initFilter(e);
        });

        $('.filter').on('click', (e) => {
            $('.filter .dropdown').toggleClass('active');
            e.stopPropagation();
        });

        $('body').on('click', (e) => {
            $('.filter .dropdown').removeClass('active');
        })
    }

    initFilter(e) {
        let $e = $(e);
        let type = $e.data('filter');
        this.filters[type] = "*";

        $e.change(() => {
            this.filters[type] = $e.find(":selected").val();
            this.filter();
        });
    }

    filter() {
        let $toFilter = $('.js-to-filter');
        $toFilter.removeClass('hide');

        for (let key in this.filters) {
            if (this.filters.hasOwnProperty(key)) {
                if (this.filters[key] !== "*") {
                    $toFilter.each((i, e) => {
                        if (!$(e).hasClass("js-" + key + "-" + this.filters[key])) {
                            $(e).addClass('hide');
                        }
                    });
                }
            }
        }

        let count = $toFilter.length - $('.js-to-filter.hide').length;
        let $noResults = $('.js-no-results');

        if (count === 0) {
            $noResults.removeClass('hide');
        } else {
            $noResults.addClass('hide');
        }
    }
}

export default Filter;











// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/filter.js